export default {"src":"/_next/static/media/InflammatoryBowelDisease.b2ded9c5.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};